/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostinghelpfblead3Inputs */

const en_crosspostinghelpfblead3 = /** @type {(inputs: Crosspostinghelpfblead3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You always connect a Facebook Page - a personal profile cannot be connected.`)
};

const de_crosspostinghelpfblead3 = /** @type {(inputs: Crosspostinghelpfblead3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du verbindest immer eine Facebook-Seite – ein privates Profil kann nicht verbunden werden.`)
};

/**
* | output |
* | --- |
* | "You always connect a Facebook Page - a personal profile cannot be connected." |
*
* @param {Crosspostinghelpfblead3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostinghelpfblead3 = /** @type {((inputs?: Crosspostinghelpfblead3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostinghelpfblead3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostinghelpfblead3(inputs)
	return de_crosspostinghelpfblead3(inputs)
});
export { crosspostinghelpfblead3 as "crosspostingHelpFbLead" }